import I18n from 'i18n-js';
import React, { useContext, useEffect } from 'react';

import { RCCheckbox, RCIcon, RCTag, RCText, RCTextWithIcon } from '@reverbdotcom/cadence/components';
import { TagIcon, InfoIcon } from '@reverbdotcom/cadence/icons/react';
import { FormCards } from '@reverbdotcom/commons/src/components/FormCards';

import { SellFormContext } from '../../SellFormContext';
import { Field, ActionType } from '../../sellFormReducerTypes';
import { withinAccessPointLimits } from '../../../../discovery/shipping_labels/shipping_label_package';

export default function CarrierCalcPickupStore() {
  const { listingEntry, dispatch } = useContext(SellFormContext);
  const packageEntry = listingEntry[Field.CARRIER_CALCULATED_PACKAGE];
  const allowPickupStore = !!packageEntry?.shipsToAccessPoints;
  const eligible = withinAccessPointLimits(packageEntry);

  // Clear a stale opt-in if the package no longer fits the access-point limits
  // (e.g. the seller edited the dimensions after opting in), so we never persist
  // a selection the backend will reject.
  useEffect(() => {
    if (!eligible && allowPickupStore) {
      dispatch({
        type: ActionType.UPDATE_FIELD,
        fieldKey: Field.CARRIER_CALCULATED_PACKAGE,
        value: { ...packageEntry, shipsToAccessPoints: false },
      });
    }
  }, [eligible, allowPickupStore, packageEntry, dispatch]);

  if (!eligible) { return null; }

  return (
    <FormCards.Card>
      <FormCards.FormSection
        title={I18n.t('discovery.sellForm.shippingSection.carrierCalcPickupStore.header')}
        fullWidthForm
      >
        <RCCheckbox
          id="carrier-calc-pickup-store"
          name="carrier-calc-pickup-store"
          checked={allowPickupStore}
          label={(
            <>
              <span className="mr-2">
                {I18n.t('discovery.sellForm.shippingSection.carrierCalcPickupStore.checkboxLabel')}
              </span>
              <RCTag variant="highlight">
                {I18n.t('commons.formGroup.recommended')}
              </RCTag>
            </>
          )}
          onChange={() => {
            dispatch({
              type: ActionType.UPDATE_FIELD,
              fieldKey: Field.CARRIER_CALCULATED_PACKAGE,
              value: { ...packageEntry, ...{ shipsToAccessPoints: !allowPickupStore } },
            });
          }}
        />

        <div className="d-flex fx-align-center bg-color-gray-100 padding-5 bd-radius-md mt-3">
          <div className="mr-2 text-color-secondary">
            <RCIcon size="rc-space-6" icon={<TagIcon />} />
          </div>
          <div className="mb-0 size-90">
            <span className="weight-bold">
              {I18n.t('discovery.sellForm.shippingSection.carrierCalcPickupStore.messageHighlight')}
            </span>
            {' '}
            {I18n.t('discovery.sellForm.shippingSection.carrierCalcPickupStore.message')}
          </div>
        </div>

        <div className="mt-3">
          <RCText.Fine htmlTag="div" color="secondary">
            <RCTextWithIcon icon={<InfoIcon />} placement="left">
              {I18n.t('discovery.sellForm.shippingSection.carrierCalcPickupStore.cancelWarning')}
            </RCTextWithIcon>
          </RCText.Fine>
        </div>
      </FormCards.FormSection>
    </FormCards.Card>
  );
}
